import { baseApi } from "./baseApi";

// Brands API
export const brandApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrands: builder.query({
      query: (params) => {
        let url = "brands";

        url += "?";

        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.name) {
          url += `name=${params.name}&`;
        }
        if (params.code) {
          url += `code=${params.code}&`;
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    createBrand: builder.mutation({
      query: (brand) => ({
        url: "brands",
        method: "POST",
        body: brand
      })
    }),
    updateBrand: builder.mutation({
      query: (params) => ({
        url: `brands/${params.id}`,
        method: "PUT",
        body: params.brand
      })
    }),
    getBrand: builder.query({
      query: (id) => `brands/${id}`
    }),
    createModel: builder.mutation({
      query: (params) => ({
        url: `brands/${params.brandId}/models`,
        method: "POST",
        body: params.modelData
      })
    }),
    updateModel: builder.mutation({
      query: (params) => ({
        url: `brands/${params.brandId}/models/${params.id}`,
        method: "PUT",
        body: params.modelData
      })
    }),
    createChargerType: builder.mutation({
      query: (params) => ({
        url: `brands/${params.brandId}/charger_types`,
        method: "POST",
        body: params.chargerTypeData
      })
    }),
    updateChargerType: builder.mutation({
      query: (params) => ({
        url: `brands/${params.brandId}/charger_types/${params.id}`,
        method: "PUT",
        body: params.chargerTypeData
      })
    })
  })
});

// Export mutations and queries
export const {
  useGetBrandsQuery,
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useGetBrandQuery,
  useCreateModelMutation,
  useUpdateModelMutation,
  useCreateChargerTypeMutation,
  useUpdateChargerTypeMutation
} = brandApi;
